import { ConstellationOneListing } from '@aloft/toolkit-shared';

export const getBathsTotalInteger = (listingData: ConstellationOneListing): string => {
  if (listingData.BathroomsTotalInteger) {
    return listingData.BathroomsTotalInteger.toString();
  }

  return (
    (listingData.BathroomsFull ?? 0) +
    (listingData.BathroomsThreeQuarter ?? 0) +
    (listingData.BathroomsHalf ?? 0)
  ).toString();
};
